"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagGE = function FlagGE(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-9H33V-122H-9.39V-9H-193V33.37H-9.39v113H33v-113H216.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-72.95-75.15c-7,.7-13.84,1.4-20.71,2.11.71-6.86,1.41-13.72,2.12-20.71a75.11,75.11,0,0,1-19.3,0c.7,7,1.4,13.85,2.11,20.71-6.86-.71-13.72-1.41-20.71-2.11a75.11,75.11,0,0,1,0,19.3L-108.73-58c-.7,6.87-1.41,13.72-2.11,20.72a74.22,74.22,0,0,1,19.3,0c-.7-7-1.41-13.85-2.12-20.72l20.71,2.12a76,76,0,0,1,0-19.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M153-75.15c-7,.7-13.85,1.4-20.71,2.11.71-6.86,1.41-13.72,2.11-20.71a75.11,75.11,0,0,1-19.3,0c.7,7,1.41,13.85,2.12,20.71-6.87-.71-13.72-1.41-20.71-2.11a76,76,0,0,1,0,19.3L117.26-58c-.71,6.87-1.41,13.72-2.12,20.72a74.22,74.22,0,0,1,19.3,0c-.7-7-1.4-13.85-2.11-20.72L153-55.85a75.11,75.11,0,0,1,0-19.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-72.95,80.21c-7,.7-13.84,1.41-20.71,2.11.71-6.86,1.41-13.71,2.12-20.71a74.22,74.22,0,0,1-19.3,0c.7,7,1.4,13.85,2.11,20.71-6.86-.7-13.72-1.41-20.71-2.11a75.11,75.11,0,0,1,0,19.3c7-.7,13.85-1.41,20.71-2.11-.7,6.86-1.41,13.72-2.11,20.71a75.11,75.11,0,0,1,19.3,0c-.7-7-1.41-13.85-2.12-20.71,6.87.7,13.72,1.41,20.71,2.11a76,76,0,0,1,0-19.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M153,80.21c-7,.7-13.85,1.41-20.71,2.11.71-6.86,1.41-13.71,2.11-20.71a74.22,74.22,0,0,1-19.3,0c.7,7,1.41,13.85,2.12,20.71-6.87-.7-13.72-1.41-20.71-2.11a76,76,0,0,1,0,19.3c7-.7,13.84-1.41,20.71-2.11-.71,6.86-1.41,13.72-2.12,20.71a75.11,75.11,0,0,1,19.3,0c-.7-7-1.4-13.85-2.11-20.71,6.86.7,13.72,1.41,20.71,2.11a75.11,75.11,0,0,1,0-19.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagGE;
exports["default"] = _default;